(function () {
  var t, n, r, i, e, a;
  (n = t = t || {}).A = 'identify';
  n.B = 'trackPageView';
  n.C = 'fireEmailCaptureEvent';
  n.D = 'fireCustomGoal';
  n.E = 'firePurchaseEvent';
  n.F = 'trackPageViewInitial';
  n.G = 'fireSlimPurchaseEvent';
  n.H = 'identifyCustomerId';
  n = '//j.northbeam.io/ota-sp/585e56e2-cdfd-4c6b-b164-f1799391a93b.js';
  window.Northbeam ||
    ((r = []),
    (i = function (n) {
      for (var e = [], t = 1; t < arguments.length; t++) e[t - 1] = arguments[t];
      r.push({ fnName: n, args: e });
    }),
    ((e = {})[t.F] = function (n) {
      i(t.F, n);
    }),
    (e = e),
    ((a = { _q: r })[t.A] = function (n, e) {
      return i(t.A, n, e);
    }),
    (a[t.B] = function (n) {
      return i(t.B, n);
    }),
    (a[t.C] = function (n, e) {
      return i(t.C, n, e);
    }),
    (a[t.D] = function (n, e) {
      return i(t.D, n, e);
    }),
    (a[t.E] = function (n) {
      return i(t.E, n);
    }),
    (a[t.G] = function (n) {
      return i(t.G, n);
    }),
    (a[t.H] = function (n, e) {
      return i(t.H, n, e);
    }),
    (a = a),
    (a = Object.assign(function (n) {
      for (var e = [], t = 1; t < arguments.length; t++) e.push(arguments[t]);
      return i.apply(null, [n].concat(e));
    }, a)),
    (window.Northbeam = a),
    ((a = document.createElement('script')).async = !0),
    (a.src = n),
    document.head.appendChild(a),
    e.trackPageViewInitial(window.location.href));
})();
